import { useState } from 'react'
import { useRouter } from 'next/router'

import { useAppSelector, useActionless } from 'redux/hooks'
import { SET_FOLDER_STATE } from 'redux/folders/actions/types'

import Modal from 'components/elements/Modal'
import PhatButton from 'components/formElements/PhatButton'
import CheckboxFancybox from 'components/formElements/CheckboxFancybox'
import PhatInput from 'components/formElements/PhatInput'
import ToastService from 'services/toast.service'
import FolderService from 'services/folder.service'
import SimpleSpinner from 'components/elements/SimpleSpinner'

import styles from './newFolderModal.module.scss'

const NewFolderModal = () => {
  const newFolderModalOpen = useAppSelector(state => state.folders.newFolderModalOpen)

  const [setFolderState] = useActionless(SET_FOLDER_STATE)

  const router = useRouter()
  const id = `${router.query.folderId}`

  const [folderName, setFolderName] = useState('')
  const [privateFolder, setPrivateFolder] = useState(false)
  const [loading, setLoading] = useState(false)

  const handleCreateFolder = (e: React.FormEvent) => {
    e.preventDefault()

    if (!folderName) return ToastService.create('Please enter a folder name', 'Folder Service ', 'error')
    if (folderName?.length > 32)
      return ToastService.create('Folder name too long. Max 32 characters', 'Folder Service', 'error')

    setLoading(true)

    FolderService.create(folderName, privateFolder, id)
      .then(folder => router.push(`/folders/${folder.id}`))
      .catch(err => ToastService.create(err, 'Folder Service', 'error'))
      .finally(() => setLoading(false))
  }

  const handleChange = (value: string) => {
    if (value.length < 32) setFolderName(value)
  }

  return (
    <Modal
      open={newFolderModalOpen}
      onClose={() => setFolderState({ newFolderModalOpen: !newFolderModalOpen })}
      closeButton>
      <h2 className={styles.header}>Create a New Folder</h2>

      <form onSubmit={handleCreateFolder} className={styles.form}>
        <PhatInput
          header="Folder Name"
          name="folderName"
          placeholder="New Folder Name"
          value={folderName}
          onChange={handleChange}
          containerClassName={styles.fullWidth}
          className={styles.fullWidth}
        />

        <CheckboxFancybox
          checked={privateFolder}
          onClick={() => setPrivateFolder(!privateFolder)}
          header="Private Folder"
          description="When a folder is private, that folder page will only load for you. Contents of the folder may still be loaded from deck search / directly"
        />

        <div className={styles.controls}>
          <PhatButton icon="checkmark" type="submit" disabled={loading} color="green" onClick={() => null}>
            {loading ? (
              <>
                <SimpleSpinner size="xSmall" /> Creating folder...
              </>
            ) : (
              <>Create folder</>
            )}
          </PhatButton>
        </div>
      </form>
    </Modal>
  )
}

export default NewFolderModal
